module.exports = __webpack_public_path__ + "img/remove_the_endcaps_2.b4643ba5.png";